module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAASCAYAAACEnoQPAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAD6ADAAQAAAABAAAAEgAAAACfRog6AAAAoUlEQVQ4EWNgoBT8//9fBYi3AfE+IPYnyTyghgNAjAyWAjlCRBkCVPgOWSeU/QJIBxA0AKjoPRbNMCGQK4RxGgKUxGYzTDOIxu0KoCQ+m5ENwXQFCZpBBoFcoQf3BomaQQbsA2lmgptABoMczS+B9hTA7SLB2cuAalGjDShAs6jCtA3uZiADh824EwaaZmwZA9VvyBqQ2UCbyc+SyAaRwgYA2PbWVYx2EVkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/conference/play.png
// module id = kvWR
// module chunks = 1